import { Button, Text } from "@solomon-labs/design/components/ui";
import type { ReactElement } from "react";

import { AccountFinalizingIllustration } from "@/pages/Positions/components/AccountFinalizingIllustration";

interface ManualVerificationPendingProps {
    issuerName?: string;
    onContinue?: () => void;
}

/** Saved manual requests remain guarded until the issuer approves the position. */
export function ManualVerificationPending({
    issuerName = "Solomon",
    onContinue
}: ManualVerificationPendingProps): ReactElement {
    return (
        <section
            aria-label="Pending verification"
            className="border-t border-line-base"
        >
            <div className="flex flex-col items-center gap-6 px-6 py-12 text-center md:py-16">
                <AccountFinalizingIllustration />
                <div className="flex max-w-lg flex-col gap-2">
                    <Text
                        variant="h2"
                        className="text-balance text-foreground-base"
                    >
                        Your position has been added for review
                    </Text>
                    <Text
                        variant="small"
                        className="text-balance text-foreground-neutral"
                    >
                        {issuerName} will contact you shortly to verify your
                        control of this position. Your position will be
                        activated after approval.
                    </Text>
                </div>
                {onContinue && (
                    <Button variant="sunken" size="md" onClick={onContinue}>
                        Continue
                    </Button>
                )}
            </div>
        </section>
    );
}
